import { NgModule } from '@angular/core';
import { SelectComponent } from './select.component';
import { SelectOptionComponent } from './select-option.component';

const MODULES = [SelectComponent, SelectOptionComponent];

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES]
})
export class SelectModule {}
